import { axiosConfigBuilder } from '..';

export class PersonaBuilderService {
  async getMediaChannels(accessToken, countryCode, kwargs) {
    const mediaChannels = await axiosConfigBuilder(accessToken).post(
      '/get_media_tree_media_usage',
      {
        countryCode,
        kwargs,
      }
    );

    return mediaChannels;
  }

  async getMediaUsage(accessToken, countryCode, ids, kwargs) {
    const mediaUsage = await axiosConfigBuilder(accessToken).post(
      '/get_media_usage',
      {
        countryCode,
        ids,
        kwargs,
      }
    );

    return mediaUsage;
  }
}
